<template>
  <v-content>
    <section id="cover">
      <div class="section-contents">
        <!-- <img
          :src="require('@/assets/images/loading.svg')"
          class="loaderImg"
        /> -->
        <h1>COMMUNITY</h1>
        <p>더브라운의 최신 소식을 전합니다</p>
      </div>
    </section>
    <section id="search">
      <v-dialog
        v-model="dialog2"
        hide-overlay
        full-width
      >
        <div class="pdf-control">
          <v-btn
            color="#3A2217"
            fab
            depressed
            small
          >
            <v-icon
              color="white"
              size="40px"
              @click="pageNo--"
            >mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            color="#3A2217"
            fab
            depressed
            small
          >
            <v-icon
              color="white"
              size="40px"
              @click="pageNo++"
            >mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn
            color="secondary"
            fab
            depressed
            small
          >
            <v-icon
              size="40px"
              @click="zoomIn()"
            >mdi-plus</v-icon>
          </v-btn>
          <v-btn
            color="secondary"
            fab
            depressed
            small
          >
            <v-icon
              size="40px"
              @click="scale -= scale > 0.2 ? 0.1 : 0"
            >mdi-minus</v-icon>
          </v-btn>
          <!-- <div style="width: 50px"></div> -->
          <v-btn
            color="secondary"
            fab
            depressed
            small
          >
            <v-icon
              size="40px"
              @click="closePDF"
            >close</v-icon>
          </v-btn>
        </div>
        <pdf
          :key="pdfKey"
          :src="activeLink"
          :scale.sync="scale"
          :page="pageNo"
          ref="pdfView"
          @loading="loader"
          style="border: 0px solid #686059; background-color: rgba(0,0,0,0);"
        >
          <template
            slot="loading"
            style="margin: auto;"
          >
            <img
              :src="require('@/assets/images/loading.svg')"
              class="loaderImg"
            />
          </template>
        </pdf>
      </v-dialog>

      <v-chip
        color="#686059"
        :text-color="isNewsLetter ? 'white' : ''"
        :outline="!isNewsLetter"
        @click="isNewsLetter =! isNewsLetter"
        class="font-weight-bold"
      >#뉴스레터
      </v-chip>
      <v-chip
        :text-color="isOpenStore ? 'white' : ''"
        :outline="!isOpenStore"
        @click="isOpenStore =! isOpenStore"
        color="#686059"
        class="font-weight-bold"
      >#매장오픈
      </v-chip>
      <v-chip
        :text-color="isPress ? 'white' : ''"
        :outline="!isPress"
        @click="isPress =! isPress"
        color="#686059"
        class="font-weight-bold"
      >#언론보도
      </v-chip>
    </section>
    <section id="news">
      <v-container
        grid-list-lg
        contents
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            md4
            xs12
            class="info-join"
          >
            <v-card
              color="#eeedec"
              tile
              elevation="0"
              class="over-hidden inquiry"
            >
              <div class="join">
                <h2>프랜차이즈 문의</h2>
                <span>1599-2757</span>
                <p>
                  창업 및 문의사항이 있으시면<br />
                  언제든지 전화주세요
                </p>
              </div>
            </v-card>
          </v-flex>
          <v-flex
            md8
            xs12
          >
            <h2>더브라운 소식</h2>
            <v-layout
              row
              wrap
              pt-3
            >
              <v-flex
                md4
                xs6
                v-for="(item) in filteredNewsList"
                :key="item.imgFileName"
              >
                <router-link :to="'/community/'+ item.id">
                  <v-card
                    tile
                    elevation="0"
                    color="secondary"
                    style="border: 1px solid #686059;"
                    @click="selectPost(item.id)"
                  >
                    <v-img
                      :src="'http://dev.thebrownbakery.co.kr/images/'+item.imgFileName"
                      cover
                      aspect-ratio="1"
                    > </v-img>
                    <!-- <span class="title-overlay">인터뷰365</span> -->
                    <div
                      class="desc-overlay"
                      :class="activePostIdx === item.id ? 'selected' : ''"
                    >
                      <div class="overlay-header">
                        <h1></h1>
                      </div>
                      <div class="overlay-body">
                        <p class="desc">{{ item.text }}</p>
                        <p class="desc-date">{{ item.update.split(/\s/)[0] }}</p>
                      </div>
                      <div class="overlay-tag"></div>
                    </div>
                  </v-card>
                </router-link>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </v-content>
</template>

<script>
import pdf from 'pdfvuer'
import _ from 'lodash'
import axios from 'axios'
export default {
  components: {
    pdf
  },
  props: ['id'],
  created () {
    // console.log(this.id)
    this.$nextTick(async () => {
      const nList = await axios.get(document.api_host + '/news.json')
        .then(({ data }) => {
          return data
        })
        .catch(err => console.error('no data ( data fetch error )'))
      // console.log(this.newsList)
      this.newsList = _.orderBy(nList, ['update'], ['desc'])
      if (this.id) {
        console.log(this.newsList.filter(n => n.id == this.id), this.id)
        this.activePost(this.id)
      }
    })
  },
  watch: {
    id (newValue, oldValue) {
      if (newValue)
        this.activePost(newValue)
    }
  },
  mounted () {
    this.scale = window.outerWidth < 640 ? 0.3 : 1;

    const isIE11 = () => { 
      var agt = navigator.userAgent.toLowerCase(); 
      if (agt.indexOf('rv:11.0')> 0) return true;
      else return false
      // if (agt.indexOf("chrome") != -1) return 'Chrome'; 
      // if (agt.indexOf("opera") != -1) return 'Opera'; 
      // if (agt.indexOf("staroffice") != -1) return 'Star Office'; 
      // if (agt.indexOf("webtv") != -1) return 'WebTV'; 
      // if (agt.indexOf("beonex") != -1) return 'Beonex'; 
      // if (agt.indexOf("chimera") != -1) return 'Chimera'; 
      // if (agt.indexOf("netpositive") != -1) return 'NetPositive'; 
      // if (agt.indexOf("phoenix") != -1) return 'Phoenix'; 
      // if (agt.indexOf("firefox") != -1) return 'Firefox'; 
      // if (agt.indexOf("safari") != -1) return 'Safari'; 
      // if (agt.indexOf("skipstone") != -1) return 'SkipStone'; 
      // if (agt.indexOf("netscape") != -1) return 'Netscape'; 
      // if (agt.indexOf("mozilla/5.0") != -1) return 'Mozilla'; 
      // if (agt.indexOf("msie") != -1) { 
      //   // 익스플로러 일 경우 
      //   var rv = -1; 
      //   if (navigator.appName == 'Microsoft Internet Explorer') { 
      //     var ua = navigator.userAgent; 
      //     var re = /MSIE ([0-9]{1,}[.0-9]{0,})/ 
      //     if (re.exec(ua) != null) 
      //     rv = parseFloat(RegExp.$1); 
      //   } 
      //   return 'Internet Explorer '+rv; 
      // } 
    }

    console.log(`Browser is ${isIE11() ? 'IE11' : 'other'}`)
    this.isIE11 = isIE11()
  },
  data () {
    return {
      isIE11 : false,
      isPress: false,
      isNewsLetter: true,
      isOpenStore: false,
      resizeToggle: true,
      activePostIdx: -1,
      activeLink: 'http://dev.thebrownbakery.co.kr/pdf/190618_Interview365.pdf',
      scale: 1,
      dialog2: false,
      pdfKey: 0,
      pageNo: 1,
      newsList: [
      ]
    }
  },
  methods: {
    closePDF() {
      this.dialog2=false
      this.pageNo = 1

    } ,   
    loader () {
      // console.log('loading... ')

    },
    zoomIn () {
      this.resizeToggle = false
      this.scale += this.scale < 2 ? 0.1 : 0
    },
    selectPost (idx) {
      if (this.id == idx)
        this.activePost(idx)
    },
    activePost (idx) {
      console.log('idx => ', idx)


      if (this.activePostIdx === idx) {
        this.activePostIdx = -1
      } else {
        this.activePostIdx = idx
      }
      const t = window.location.protocol + "//" + window.location.hostname + '/pdf/' + (this.newsList.filter(n => n.id == idx)[0]).pdfFileName
      // console.log(t)
      this.activeLink = t
      // console.log(this.activeLink)
      this.pdfKey += 1;
      // this.$set(this.$refs.pdfView, 'src', t)
      
      if(!this.isIE11) {
      this.dialog2 = true;
      }else {
        window.open(t, '_blank'); 


      }
    }
  },
  computed: {
    filteredNewsList () {
      let f = []
      if (this.isPress)
        f = f.concat(this.newsList.filter(n => n.category === 'press'))
      if (this.isNewsLetter)
        f = f.concat(this.newsList.filter(n => n.category === 'newsLetter'))
      if (this.isOpenStore)
        f = f.concat(this.newsList.filter(n => n.category === 'openStore'))
      return f
    }
  }
}
</script>

<style lang="css" scoped>
#cover {
  background-image: url("/images/TB_community.jpg");
  /* background-size: 1500px auto; */
  background-size: cover;
  background-position: center 80%;
  margin-top: 130px;
  /* background-attachment: fixed; */
  /* background-position: 10px 130px; */
  /* background-position-y: 100px; */
  background-repeat: repeat-x;
  max-width: 1500px;
  margin: 130px auto 0px auto;
  height: 470px;
  color: white;
}
/*
#cover div.section-contents {
  display: flex;
  justify-content: flex-start;
} */

#cover h1 {
  font-family: "europa";
  /* flex-basis: 33.33%; */
  font-size: 70px;
  font-weight: 600;
  /* letter-spacing: -3px; */
}
#cover p {
  font-family: "NanumSquare";
  padding-top: 20px;
  font-weight: 600;
  /* flex-basis: 66.66%; */
  font-size: 20px;
}
#search {
  height: 90px;
  max-width: 1420px;
  margin: auto;
  border-bottom: 5px solid #686059;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

#news {
  width: 100%;
  padding: 0px 20px;
  /* border: 1px solid red; */
}
#news .contents {
  max-width: 1468px !important;
  padding-top: 40px !important;
  /* background-color: powderblue; */
}

#news h2 {
  font-weight: 900;
  font-size: 20px;
  color: #686059;
}
#news div.join span {
  padding: 10px 0px;
  font-weight: 600;
  font-size: 40px;
  font-family: "europa";
  color: #b37039;
  /* color: #d5c0af; */
}
#news div.join p {
  color: #686059;
  font-size: 14px;
  line-height: 18px;
}

div.v-dialog.pdf-modal {
  box-shadow: initial;
}
.v-image__image {
  transition: left 400ms, right 400ms, transform 400ms;
}

div.v-responsive.v-image:hover .v-image__image {
  /* transform: scale(1.2); */
}

div.v-responsive.v-image:hover ~ .desc-overlay {
  background-color: rgba(104, 96, 89, 0.8);
  opacity: 1;
}

span.title-overlay {
  text-align: center;
  display: block;
  /* width: 300px; */
  height: 30px;
  position: absolute;
  top: 85%;
  left: 50%;
  font-size: 20px;
  font-weight: 600;
  color: #686059;
  /* text-shadow: 1px 2px 3px grey; */
  z-index: 100;
  transform: translateX(-50%);
  transition: opacity 0.3s ease-out;
}
.selected {
  background-color: rgba(104, 96, 89, 0.8) !important;
  opacity: 1 !important;
}
.pdf-control {
  padding: 20px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* border: 1px solid #686059;
  background-color: rgba(0,0,0,0.4); */
  /* border: 2px solid slateblue; */
}

@keyframes bounce {
  0%,
  20%,
  60%,
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
  }
  80% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
}
img.loaderImg {
  display: block;
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -60px;
  margin-top: -60px;
  height: 120px;
  animation: bounce 2s ease-in-out 0s infinite;
}
div.desc-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  /* top: -100%; */
  left: 0;
  top: 0;
  opacity: 0;
  color: white;
  /* background-color: rgba(104, 96, 89, 0.8); */
  /* opacity: 1; */
  /* background-color: rgba(104, 96, 89, 0.8); */
  transition: all 0.5s ease-in;
  padding: 0;
  z-index: 100;
  pointer-events: none;
  display: flex;
  flex-direction: column;
}

div.desc-overlay > div.overlay-header {
  max-height: 30%;
  flex: 1 1 30%;
  /*min-height: 60px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

div.desc-overlay > div.overlay-header h1 {
  font-family: "NanumSquare";
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  /* text-shadow: 0 0 2px white; */
}
div.desc-overlay > div.overlay-body {
  /* max-height: 80%;
  height: 60%;; */
  padding: 0% 10%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1 50%;
}

div.desc-overlay > div.overlay-body p {
  padding-right: 15%;
  text-align: left;
  word-break: keep-all;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -1px;
}

div.desc-overlay > div.overlay-body p.desc-date {
  margin-top: 10px;
  font-size: 16px;
}

div.desc-overlay div.overlay-tag {
  flex: 1 1 20%;
}
div.desc-overlay div.overlay-tag ul {
  padding-left: 0px !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -1px;
  color: #fbd2af;
}
/* .signature-menu div.desc-overlay > div.overlay-tag ul {} */
div.desc-overlay div.overlay-tag li {
  margin: 0px 3px;
}
div.desc-overlay div.overlay-tag li:before {
  content: "#";
}

@media (max-width: 1023px) {
  #cover {
    margin-top: 80px;
    height: 220px;
    /* background-size: auto 220px;
    background-position-y: 80px;
    background-position-x: left; */
  }
  #cover .section-contents {
    padding: 20px;
    display: flex;
    flex-direction: column;
  }
  #cover h1 {
    font-size: 40px;
  }
  #cover p {
    padding: 0px;
    max-width: 260px;
    font-size: 18px;
    /* display: none; */
  }

  #search {
    display: none;
  }
  #news {
    margin-top: 20px;
  }
  #news .contents {
    padding: 0px 0px !important;
  }
  #news div.info-join {
    display: none;
  }
  div.desc-overlay > div.overlay-body p {
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -1px;
  }

  div.desc-overlay > div.overlay-body p.desc-date {
    margin-top: 0px;
    font-size: 16px;
  }
  img.loaderImg {
    display: block;
    height: 60px;
    margin-top: -30px;
    margin-left: -30px;
  }
}
</style>